<ion-content>
  <app-global-page-header
    [title]="'P00039.parameters.setting.clockweek' | translate"
  >
    <div slot="end">
      <ion-button
        color="medium"
        fill="clear"
        shape="round"
        (click)="dismissModal()"
      >
        <i class="fa-solid fa-times"></i>
      </ion-button>
    </div>
  </app-global-page-header>

  <div class="text-center">
    <div
      class="d-inline-block position-relative overflow-hidden"
      style="width: 300px; height: 300px"
    >
      <img
        src="/assets/ecosystem/images/horlogeLight@3x.png"
        [alt]="
          'components.functionParametersSettingClockWeek.clockScreenAlt'
            | translate
        "
        style="height: 100%; width: 100%"
      />

      <div class="position-absolute top-0 start-0 end-0 bottom-0">
        <div class="row h-100 align-content-center">
          <div class="col text-center">
            <div class="d-block color-medium">
              {{
                'components.functionParametersSettingClockWeek.totalTime'
                  | translate
              }}
            </div>
            <div class="d-block fw-bold">
              {{ tempsTotal() }}
            </div>
          </div>
        </div>
      </div>

      @for (testModel of this.horlogesModel; track testModel) {
        <div
          class="position-absolute"
          style="top: -150px; bottom: -150px; left: -150px; right: -150px"
        >
          <div class="row h-100 align-content-center">
            <div class="col text-center">
              <div
                class="d-inline-block"
                [style]="
                  'transform: rotate(' +
                  transformNumberToDegree(testModel.start) +
                  'deg);'
                "
              >
                <circle-progress
                  [percent]="
                    ((transformNumberToDegree(testModel.end) -
                      transformNumberToDegree(testModel.start)) *
                      100) /
                    360
                  "
                  [radius]="127"
                  [backgroundPadding]="0"
                  [showTitle]="false"
                  [showSubtitle]="false"
                  [showUnits]="false"
                  [showBackground]="true"
                  [outerStrokeWidth]="35"
                  [innerStrokeWidth]="0"
                  [outerStrokeColor]="
                    AppComponent.currentBrand?.getMainColor() ?? '#f39200'
                  "
                  [animation]="false"
                  [animationDuration]="0"
                  [outerStrokeLinecap]="'butt'"
                ></circle-progress>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  @if (this.horlogesModel.length > 0) {
    <div class="my-4">
      <div class="px-4 mb-3">
        <ion-label class="color-medium text-uppercase fw-bold">{{
          'functions.horlogeprogrammation.clock.plageprogramme' | translate
        }}</ion-label>
      </div>

      @for (testModel of this.horlogesModel; track testModel) {
        <ion-list lines="none">
          <ion-item
            class="pointer-hover py-1 px-4"
            (click)="openModal(testModel)"
          >
            <ion-label>
              {{ secondeToHourMinute(testModel.start) }}
              {{ 'functions.horlogeprogrammation.timer.a' | translate }}
              {{ secondeToHourMinute(testModel.end) }}
            </ion-label>

            <div slot="end">
              <i class="fa-regular fa-pen color-primary"></i>
            </div>
          </ion-item>
        </ion-list>
      }
    </div>
  }

  <!-- Modal inline -->
  <ion-modal [isOpen]="isModalOpen" (didDismiss)="closeModal()">
    <ng-template>
      @if (selectModelStep === 0) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <ion-label class="color-medium text-uppercase fw-bold">
                {{ 'selectTimeInterval.start' | translate }}
              </ion-label>
            </div>

            <div>
              <ion-list lines="none">
                @for (item of this.list; track item.ref) {
                  <ion-item
                    class="pointer-hover py-1 px-4"
                    (click)="selectStart(item.ref)"
                  >
                    <ion-label>
                      <span
                        [class.color-primary]="selectModel?.start === item.ref"
                      >
                        {{ item.label | translate }}
                      </span>
                    </ion-label>

                    @if (selectModel?.start === item.ref) {
                      <div slot="end" class="color-primary">
                        <i class="fa-regular fa-check"></i>
                      </div>
                    }
                  </ion-item>
                }
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button expand="block" color="primary" (click)="nextStep()">
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      } @else if (selectModelStep === 1) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <ion-label class="color-medium text-uppercase fw-bold">
                {{ 'selectTimeInterval.end' | translate }}
              </ion-label>
            </div>

            <div>
              <ion-list lines="none">
                @for (item of this.list; track item.ref) {
                  <ion-item
                    class="pointer-hover py-1 px-4"
                    (click)="selectEnd(item.ref)"
                  >
                    <ion-label>
                      <span
                        [class.color-primary]="selectModel?.end === item.ref"
                      >
                        {{ item.label | translate }}
                      </span>
                    </ion-label>

                    @if (selectModel?.end === item.ref) {
                      <div slot="end" class="color-primary">
                        <i class="fa-regular fa-check"></i>
                      </div>
                    }
                  </ion-item>
                }
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button expand="block" color="primary" (click)="nextStep()">
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      } @else if (selectModelStep === 2) {
        <ion-content>
          <div class="py-4">
            <div class="px-4 mb-3">
              <div class="row">
                <div class="col">
                  <ion-label class="color-medium text-uppercase fw-bold">{{
                    'selectTimeInterval.plage' | translate
                  }}</ion-label>
                </div>
                <div class="col-auto">
                  <div
                    class="d-inline-block pointer-hover"
                    (click)="deleteModel()"
                  >
                    <i class="fa-regular fa-trash color-primary"> </i>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <ion-list lines="none">
                <ion-item class="pointer-hover py-1 px-4" (click)="goToStep(0)">
                  <ion-label>
                    {{ 'selectTimeInterval.start' | translate }}
                  </ion-label>

                  <div slot="end">
                    {{ getStartDate() }}
                  </div>
                </ion-item>
                <ion-item class="pointer-hover py-1 px-4" (click)="goToStep(1)">
                  <ion-label>
                    {{ 'selectTimeInterval.end' | translate }}
                  </ion-label>

                  <div slot="end">
                    {{ getEndDate() }}
                  </div>
                </ion-item>
              </ion-list>
            </div>
          </div>
        </ion-content>

        <ion-footer>
          <div class="p-3">
            <div class="row">
              <div class="col-6 text-start">
                <ion-button
                  expand="block"
                  fill="outline"
                  color="medium"
                  (click)="closeModal()"
                >
                  {{ 'selectTimeInterval.cancel' | translate }}
                </ion-button>
              </div>
              <div class="col-6 text-end">
                <ion-button
                  expand="block"
                  color="primary"
                  (click)="saveModel()"
                >
                  {{ 'selectTimeInterval.save' | translate }}
                </ion-button>
              </div>
            </div>
          </div>
        </ion-footer>
      }
    </ng-template>
  </ion-modal>
</ion-content>

<ion-footer>
  <div class="p-3">
    <div class="row">
      <div class="col-12">
        <ion-button color="primary" expand="block" (click)="openModal()">
          {{ 'functions.horlogeprogrammation.clock.btn' | translate }}
        </ion-button>
      </div>
    </div>
  </div>
</ion-footer>
